import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { BedtimeProvider } from "./components/BedtimeMode";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import BrowsePage from "./pages/BrowsePage";
import ShowDetailPage from "./pages/ShowDetailPage";
import WatchPage from "./pages/WatchPage";
import TVSchedulePage from "./pages/TVSchedulePage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import FavoritesPage from "./pages/FavoritesPage";
import AdminPage from "./pages/AdminPage";
import PricingPage from "./pages/PricingPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PlaylistsPage from "./pages/PlaylistsPage";
import PlaylistDetailPage from "./pages/PlaylistDetailPage";
import KidProfilesPage from "./pages/KidProfilesPage";
import FAQPage from "./pages/FAQPage";
import SettingsPage from "./pages/SettingsPage";
import DonatePage from "./pages/DonatePage";
import TermsPage from "./pages/TermsPage";
import MaintenancePage from "./pages/MaintenancePage";
import AskGrownUp from "./components/AskGrownUp";
import VisitTracker from "./components/VisitTracker";

// ============================================================================
//  MAINTENANCE MODE
//  Flip to `false` once the attorney has cleared the site to bring it back
//  online for the public.
//
//  Owner bypass (still see the real site while public sees the holding page):
//    Visit https://retroplaygroundtv.com/?owner-preview=let-me-in
//    That URL sets a localStorage flag and you'll see the normal site on
//    that browser until you clear it (localStorage key: rptv_owner_bypass).
// ============================================================================
const MAINTENANCE_MODE = false;
const OWNER_BYPASS_KEY = "rptv_owner_bypass";
const OWNER_BYPASS_TOKEN = "let-me-in";

function isOwnerBypassed() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("owner-preview") === OWNER_BYPASS_TOKEN) {
      localStorage.setItem(OWNER_BYPASS_KEY, "1");
      return true;
    }
    return localStorage.getItem(OWNER_BYPASS_KEY) === "1";
  } catch {
    return false;
  }
}

function App() {
  if (MAINTENANCE_MODE && !isOwnerBypassed()) {
    return <MaintenancePage />;
  }

  return (
    <AuthProvider>
      <BedtimeProvider>
      <BrowserRouter>
        <div className="page-container">
          <VisitTracker />
          <Navbar />
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/browse" element={<BrowsePage />} />
            <Route path="/show/:showId" element={<ShowDetailPage />} />
            <Route path="/watch/:episodeId" element={<WatchPage />} />
            <Route path="/tv-schedule" element={<TVSchedulePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/favorites" element={<FavoritesPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/pricing" element={<DonatePage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/playlists" element={<PlaylistsPage />} />
            <Route path="/playlists/:slug" element={<PlaylistDetailPage />} />
            <Route path="/profiles" element={<KidProfilesPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </div>
      </BrowserRouter>
      </BedtimeProvider>
    </AuthProvider>
  );
}

export default App;
